import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import "./how-to-panel.less";
export default function HowToPanel({ steps, url, linkText, codeBlock, codeBlocks }) {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const activeCode = codeBlocks ? (codeBlocks[activeTab]?.code ?? "") : (codeBlock ?? "");
    const hasCode = codeBlocks ? codeBlocks.length > 0 : !!codeBlock;
    function handleCopy() {
        if (!activeCode)
            return;
        void navigator.clipboard.writeText(activeCode).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }
    function handleTabClick(i) {
        setActiveTab(i);
        setCopied(false);
    }
    return (_jsxs("div", { className: "HGU__instructions", children: [_jsx("button", { className: "HGU__instructions-toggle", onClick: () => setOpen((v) => !v), children: open ? "▲ Hide" : "▼ How to" }), open && (_jsxs("div", { className: "HGU__instructions-body", children: [_jsx("ol", { className: "HGU__instructions-list", children: steps.map((step, i) => (_jsx("li", { children: step }, i))) }), hasCode && (_jsxs("div", { className: "HGU__instructions-code-wrapper", children: [codeBlocks && (_jsx("div", { className: "HGU__instructions-tabs", children: codeBlocks.map((tab, i) => (_jsx("button", { className: `HGU__instructions-tab${i === activeTab ? " HGU__instructions-tab--active" : ""}`, onClick: () => handleTabClick(i), children: tab.label }, i))) })), _jsx("pre", { className: "HGU__instructions-code", children: activeCode }), _jsx("button", { className: "HGU__instructions-copy", onClick: handleCopy, children: copied ? "Copied!" : "Copy" })] })), url && linkText && (_jsxs("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: "HGU__instructions-link", children: [linkText, " \u2197"] }))] }))] }));
}
